import React from "react";
import "./styles.scss";
import { ReactComponent as MostPlayedIcon } from "../../../../public/most-played.svg";
import { ReactComponent as MostRepostedIcon } from "../../../../public/most-reposted.svg";
import { ReactComponent as MostLikedIcon } from "../../../../public/most-liked.svg";
import FiltersToolbar from "./FiltersToolbar";
import { indexMedia, deleteMedium } from "../../../../api/media";
import _ from "lodash";
import FullPageSpinner from "../../../FullPageSpinner";
import TracksFilters from "./TracksFilters";
import { log_error } from "../../../../api";
import UserSquareTag from "../../shared/UserSquareTag";
import { watch } from "../../../../api/helper";
import { indexAlbums } from "../../../../api/albums";
import AlbumSquareTag from "../../shared/Album/AlbumSquareTag";
import WelcomeMessage from "./WelcomeMessage";
import DashboardAudioTag from "../../shared/MediaTag/DashboardAudioTag";

export default class DashboardContents extends React.Component {
  state = {
    elements: null,
    resource: "SoundTrack",
    trackFilter: "-play_count",
  };
  componentDidMount = async () => {
    await this.getResource();
  };
  componentDidUpdate = (prevProps, prevState) =>
    watch(this.state, prevState, "resource") || watch(this.state, prevState, "trackFilter") ? this.getResource() : null;

  getResource = async () => {
    try {
      this.setState({ elements: null });
      let elements = [];
      if (this.state.resource === "SoundTrack") {
        let {
          data: { media },
        } = await indexMedia({
          page_size: 8,
          page_number: 0,
          sort: this.state.trackFilter,
          filter: {
            user_id: this.props.current_user.id,
            type: "SoundTrack",
          },
        });
        elements = media;
      } else if (this.state.resource === "Album") {
        let {
          data: { albums },
        } = await indexAlbums({
          page_size: 8,
          page_number: 0,
          sort: this.state.trackFilter,
          filter: {
            user_id: this.props.current_user.id,
          },
        });
        elements = albums;
      }
      this.setState({ elements });
    } catch (error) {
      this.setState({ elements: [] });
      console.log(log_error(error));
    }
  };

  cardWithIcon = (Icon, label, stat) => (
    <div className="col-33 text-center most-column">
      <Icon />
      <span className="d-block">
        <b className="text-uppercase">{label}</b>
      </span>
      <span>{stat ? stat.medium.title : "No data yet"}</span> <br />
      <span>{stat ? `${stat.times} ${stat.times === 1 ? "time" : "times"}` : null}</span>
    </div>
  );

  removeFromDashboard = async (mediumId) => {
    try {
      await deleteMedium(mediumId);
      this.setState((prevState) => {
        return {
          elements: prevState.elements.filter((medium) => medium.id !== mediumId),
        };
      });
    } catch (err) {
      console.log("err =>", err);
    }
  };

  render() {
    const welcomeMessageVisible = this.props.current_user.is_play_count_zero;
    var city = this.props.myDashboard.most_popular_in.city;
    var popular_state = this.props.myDashboard.most_popular_in.state;

    return (
      <>
        <div id="dashboard-contents" className={`dashboard-contents p-4 ${welcomeMessageVisible ? "message-visible" : ""}`}>
          <h1>Dashboard</h1>
          <div className="row">
            <FiltersToolbar selected={this.props.time_window} onSelectFilter={this.props.update_time_window} />
            {this.cardWithIcon(MostPlayedIcon, "most played", this.props.myDashboard.play_count)}
            {this.cardWithIcon(MostRepostedIcon, "most reposted", this.props.myDashboard.shared_count)}
            {this.cardWithIcon(MostLikedIcon, "most liked", this.props.myDashboard.likes_count)}

            <div className="col-33 text-center most-column pt-4">
              <img className="flag profile-picture rounded-circle" src={this.props.myDashboard.most_popular_in.flag} alt="" />
              <span className="d-block">
                <b>MOST POPULAR IN</b>
              </span>
              <span>
                {city ? `${city}${popular_state ? `,${" "}` : ""}` : null}
                {popular_state ? `${popular_state}` : null}
              </span>
              <br />
              <span>{this.props.myDashboard.most_popular_in.country}</span>
            </div>
            <div className="col-66 pt-3 most-column listeners-column text-center">
              <h2>TOP LISTENERS</h2>
              <div className="row pt-3">
                {this.props.myDashboard.top_listeners.map((listener) => (
                  <div className="col-33">
                    <UserSquareTag className="d-block" user={listener} />
                  </div>
                ))}
              </div>
            </div>
            <div className="col-100 pt-3">
              <h2>Your Tracks</h2>
              <TracksFilters
                selectedTrackFilter={this.state.trackFilter}
                onSelectFilter={(a) => this.setState({ trackFilter: a })}
                selectedResource={this.state.resource}
                onChangeResource={(a) => this.setState({ resource: a })}
              />
              {_.isNull(this.state.elements) ? (
                <FullPageSpinner />
              ) : this.state.resource === "SoundTrack" ? (
                <div className="row">
                  {this.state.elements.map((medium, index) => (
                    <div className="col-xl-50 media d-flex align-items-center">
                      <span className="d-inline align-self-center track-number mr-3">
                        <b>{index + 1}</b>
                      </span>
                      <div className="media-body">
                        <DashboardAudioTag
                          className="media-tag"
                          showActions
                          medium={medium}
                          removeMedium={this.removeFromDashboard}
                          user={this.props.current_user}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="d-flex flex-wrap justify-content-start">
                  {this.state.elements.map((album, index) => (
                    <AlbumSquareTag album={album} />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
        {welcomeMessageVisible && <WelcomeMessage userType={this.props.current_user.user_type} />}
      </>
    );
  }
}
